import axiosInstance from '../utils/AxiosConfig';
import dayjs from 'dayjs';

import { DEFAULT_CURRENCY, getActiveCurrency } from '../utils/currency';
export const getProfitabilityDashboardData = async ({ month, year, rut, locationId }) => {
  const start = dayjs(`${year}-${String(month).padStart(2, '0')}-01`);
  const end = start.endOf('month');

  const params = {
    from: start.format('YYYY-MM-DD'),
    to: end.format('YYYY-MM-DD'),
  };

  if (rut) {
    params.rut = rut;
  }

  if (locationId) {
    params.locationId = locationId;
  }

  if (getActiveCurrency() !== DEFAULT_CURRENCY) params.currency = getActiveCurrency();
  const response = await axiosInstance.get('/reports/profitability', { params });
  return response.data;
};
